import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseElement } from '../base-element';
import { FormEvent } from '../../../crud/form/form-event.enum';

@Component({
  selector: 'checkbox-group-base',
  templateUrl: './base-checkbox-group.component.html',
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseCheckboxGroupComponent),
    multi: true
  } ]
})
export class BaseCheckboxGroupComponent extends BaseElement<string> implements OnInit {

  @Input() values: any[] = [];
  @Input() labels: string[] = [];
  @Input() placeholder: string;
  @Input() id: string;

  error = '';

  ngOnInit(): void {
    this.form.controls[this.formControlName].setValue(this.form.controls[this.formControlName].value || []);
    if (this.label && this.isRequired) {
      this.label += ' *';
    }
    this.channel.subscribe((event: FormEvent) => {
      if (event === FormEvent.SUBMIT) {
        if (this.form.controls[this.formControlName].invalid) {
          this.toggleInvalidClass(true);
          this.renderErrors();
        } else {
          this.toggleInvalidClass(false);
        }
      }
    });
  }

  onChange($event, value): void {
    this.error = '';
    this.toggleInvalidClass(false);

    const control = this.form.controls[this.formControlName];
    if (!control.value) {
      control.setValue([]);
    }

    if (!$event.target.checked) {
      let cur = control.value || [];
      const pos = control.value.findIndex(v => v === value);
      if (pos > -1) {
        cur.splice(pos, 1);
        this.form.controls[this.formControlName].setValue(cur);
      }
    } else {
      let cur = this.form.controls[this.formControlName].value;
      if (!Array.isArray(cur)) {
        cur = [];
      }
      this.form.controls[this.formControlName].setValue([ ...cur, value ]);
    }
    if (this.change) {
      this.change.emit(this.form.controls[this.formControlName].value);
    }
  }

  protected toggleInvalidClass(flag: boolean): void {
    this.customClass = Object.assign(this.customClass, { 'is-invalid': flag });
  }

  protected renderErrors(): void {
    this.error = '';
    if (!this.errorMessages) {
      return;
    }

    if (typeof this.errorMessages === 'string') {
      this.error = this.errorMessages;
    } else {
      const errors = this.form.controls[this.formControlName].errors;
      for (const validator of Object.keys(errors)) {
        if (errors[validator]) {
          this.error += this.errorMessages[validator] + '<br />';
        }
      }
    }
  }
}
